import Vue from 'vue'
import Router from 'vue-router'
import { AllRouter } from './router'
import Cookies from 'js-cookie'

Vue.use(Router)

const RouterConfig = {
    mode: 'history',
    routes: AllRouter
}

const router = new Router(RouterConfig)

router.beforeEach((to, from, next) => {
    next() 
})

router.afterEach((to, from) => {
    window.scrollTo(0, 0);
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js